import { mapPayments } from "./paymentMapper";

export const mapCreditNoteSale = (formData: any) => {
  return {
    saleId: formData.id ?? null,                      // ← necesario si es edición, opcional en creación
    branch: formData.branch ?? null,                  // ← sucursal, si aplica
    customer: formData.customer ?? null,              // ← cliente asociado a la devolución
    documentType: formData.documentType ?? null,      // ← tipo de documento de la nota de crédito
    saleDate: formData.saleDate,                      // ← fecha de la nota de crédito
    paymentCondition: formData.paymentCondition ?? null, // 👈 si se requiere en backend
    // paymentMethod: formData.paymentMethod ?? null,    // 👈 forma de pago
    // individualPayments: formData.individualPayments || {}, // 👈 si aplica pagos individuales
    payments: mapPayments(formData.payments),
    comments: formData.comments || null,              // ← comentarios opcionales
    creditFiscalId: formData.creditFiscalId ?? null,  // 👈 importante si la nota está ligada a un crédito fiscal
  };
};
